import { HttpErrorResponse } from '@angular/common/http';

export type StartupFailureKind = 'auth-recovery' | 'access-denied' | 'startup-error' | 'system-unavailable' | 'none';

export function extractOutcomeCode(error: unknown): string {
  if (!(error instanceof HttpErrorResponse)) return '';
  const header = error.headers?.get('X-CM-Auth-Outcome');
  const body = error.error;
  const code = body && typeof body === 'object' ? body.code : undefined;
  return header || (typeof code === 'string' ? code : '');
}

export function classifyStartupResponse(error: unknown): StartupFailureKind {
  if (!(error instanceof HttpErrorResponse)) return 'none';
  if (error.status === 401) return 'auth-recovery';
  if (error.status === 403) return 'access-denied';
  if (error.status === 503 && extractOutcomeCode(error) === 'dependency_unavailable') return 'startup-error';
  if ([0, 502, 503, 504].includes(error.status)) return 'system-unavailable';
  return 'none';
}

export function isStaticStartupRoute(url: string): boolean {
  const segment = url.split(/[?#]/)[0].split('/').filter(Boolean)[0];
  return ['access-denied', 'startup-error', 'system-unavailable'].includes(segment);
}
